import Vue from 'vue'

export default {
  getAll () {
    return Vue.http.get(`/product_combos`)
  },

  get (id) {
    return Vue.http.get(`/product_combos/${id}`)
  },

  patch (id, data) {
    // Fix Laravel patch route not accept multipart/form-data encode type
    if (data instanceof FormData) {
      data.append('_method', 'PATCH')
      return Vue.http.post(`/product_combos/${id}`, data)
    }

    return Vue.http.patch(`/product_combos/${id}`, data)
  },

  store (data) {
    return Vue.http.post(`/product_combos`, data)
  }
}



// WEBPACK FOOTER //
// ./src/services/combo.js